import { createModelSegment } from 'client/data/luckdragon/segment';
import { CalculatorsModel, getStoredSelectionsPath } from 'client/data/models/calculators';
import { InventoryModel, InventoryPaths } from 'client/data/models/inventory';
import {
  filterLeaseIncentivesByTerm,
  getLoanPrimaryIncentives,
  getLeasePrimaryIncentives,
} from 'site-modules/shared/utils/incentives/incentives-service';
import PropTypes from 'prop-types';

const Incentive = PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  primary: PropTypes.bool,
  rebateAmount: PropTypes.number,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  grantor: PropTypes.string,
  compatibleIncentiveIds: PropTypes.arrayOf(PropTypes.string),
  restrictions: PropTypes.string,
});

export const InventoryIncentivesEntities = {
  Incentive,
};

export function getLoanSelectedIdsPath(vin) {
  return vin ? `${vin}.loan.selectedIds` : null;
}

export function getLeaseSelectedIdsPath(vin) {
  return vin ? `${vin}.lease.selectedIds` : null;
}

export const InventoryIncentivesModel = createModelSegment('inventoryIncentives', [
  /**
   * @see getLoanSelectedIdsPath
   */
  {
    path: '{vin}.loan.selectedIds',
    async resolve(match, context) {
      const vinData = await context.resolveValue(InventoryPaths.buildVinPath(match.vin), InventoryModel);

      if (!vinData) {
        return [];
      }

      return getLoanPrimaryIncentives({ vinData }).map(({ id }) => id);
    },
  },
  /**
   * @see getLeaseSelectedIdsPath
   */
  {
    path: '{vin}.lease.selectedIds',
    async resolve(match, context) {
      const [vinData, leaseSelection] = await Promise.all([
        context.resolveValue(InventoryPaths.buildVinPath(match.vin), InventoryModel),
        context.resolveValue(getStoredSelectionsPath({ isPurchase: false }), CalculatorsModel, false),
      ]);

      if (!vinData) {
        return [];
      }

      const primaryLeaseIncentives = getLeasePrimaryIncentives({ vinData });

      return filterLeaseIncentivesByTerm(primaryLeaseIncentives, leaseSelection?.numberOfMonths).map(({ id }) => id);
    },
  },
]);
